import { render, staticRenderFns } from "./Artisan.vue?vue&type=template&id=29545277"
import script from "./Artisan.vue?vue&type=script&lang=js"
export * from "./Artisan.vue?vue&type=script&lang=js"
import style0 from "./Artisan.vue?vue&type=style&index=0&id=29545277&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports